import { createSlice } from '@reduxjs/toolkit';
import {
  createProvidentFund,
  fetchAllProvidentFunds,
  fetchProvidentFundById,
  updateProvidentFund,
  deleteProvidentFund,
  fetchPFMonthlySummary
} from './providentFundActions';

import { ProvidentFundState } from './providentFundTypes';

const initialState: ProvidentFundState = {
  records: [],
  selectedRecord: undefined,
  pfSummary:undefined,
  loadingStates: {
    create: false,
    fetchAll: false,
    fetchById: false,
    update: false,
    delete: false,
    fetchPfSummary:false
  },
  errors: {}
};

const providentFundSlice = createSlice({
  name: 'providentFund',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Create
      .addCase(createProvidentFund.pending, (state) => {
        state.loadingStates.create = true;
        state.errors.create = undefined;
      })
      .addCase(createProvidentFund.fulfilled, (state, action) => {
        state.loadingStates.create = false;
        state.records.push(action.payload.data);
      })
      .addCase(createProvidentFund.rejected, (state, action) => {
        state.loadingStates.create = false;
        state.errors.create = action.payload as string;
      })

      // Get All
      .addCase(fetchAllProvidentFunds.pending, (state) => {
        state.loadingStates.fetchAll = true;
        state.errors.fetchAll = undefined;
      })
      .addCase(fetchAllProvidentFunds.fulfilled, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.records = action.payload.data;
      })
      .addCase(fetchAllProvidentFunds.rejected, (state, action) => {
        state.loadingStates.fetchAll = false;
        state.errors.fetchAll = action.payload as string;
      })

      // Get By ID
      .addCase(fetchProvidentFundById.pending, (state) => {
        state.loadingStates.fetchById = true;
        state.errors.fetchById = undefined;
      })
      .addCase(fetchProvidentFundById.fulfilled, (state, action) => {
        state.loadingStates.fetchById = false;
        state.selectedRecord = action.payload.data;
      })
      .addCase(fetchProvidentFundById.rejected, (state, action) => {
        state.loadingStates.fetchById = false;
        state.errors.fetchById = action.payload as string;
      })

      // Update
      .addCase(updateProvidentFund.pending, (state) => {
        state.loadingStates.update = true;
        state.errors.update = undefined;
      })
      .addCase(updateProvidentFund.fulfilled, (state, action) => {
        state.loadingStates.update = false;
        const index = state.records.findIndex(rec => rec.provident_fund_id === action.payload.id);
        if (index !== -1) {
          state.records[index] = { ...action.payload.data, provident_fund_id: action.payload.id };
        }
      })
      .addCase(updateProvidentFund.rejected, (state, action) => {
        state.loadingStates.update = false;
        state.errors.update = action.payload as string;
      })
    builder
      // Fetch Monthly Summary
      .addCase(fetchPFMonthlySummary.pending, (state) => {
        state.loadingStates.fetchPfSummary = true;
        state.errors.fetchPfSummary = undefined;
      })
      .addCase(fetchPFMonthlySummary.fulfilled, (state, action) => {
        state.loadingStates.fetchPfSummary = false;
        state.pfSummary = action.payload.data;
      })
      .addCase(fetchPFMonthlySummary.rejected, (state, action) => {
        state.loadingStates.fetchPfSummary = false;
        state.errors.fetchPfSummary = action.payload as string;
      })
      // Delete
      .addCase(deleteProvidentFund.pending, (state) => {
        state.loadingStates.delete = true;
        state.errors.delete = undefined;
      })
    .addCase(deleteProvidentFund.fulfilled, (state, action) => {
      state.loadingStates.delete = false;
      state.records = state.records.filter(r => r.provident_fund_id !== action.payload);
    })
    .addCase(deleteProvidentFund.rejected, (state, action) => {
      state.loadingStates.delete = false;
      state.errors.delete = action.payload as string;
    });
}
});

export default providentFundSlice.reducer;
